import { Formik } from "formik";
import { observer } from "mobx-react-lite";
import { Button, Form, Grid, Header, Tab, Segment } from "semantic-ui-react";
import { GameLocationPicker } from "../../components/map/GameLocationPicker";
import { useStore } from "../../app/stores/store";
import { useTranslation } from 'react-i18next'; // Add this import for i18n

export default observer(function SetupProfileLocation() {
  const { profileStore, userStore } = useStore();
  const { updatingLocation, updateUserLocation } = profileStore;
  const { t } = useTranslation(); // Initialize translation hook

  return (
    <Tab.Pane loading={updatingLocation}>
      <Grid>
        <Grid.Column width={16}>
          <Header
            floated="left"
            icon="user"
            content={t('setupProfileLocation.locationDescription')}
          />
        </Grid.Column>

        <Grid.Column width={16}>
          <Segment padded>
            <Formik
              enableReinitialize
              initialValues={{
                latitude: userStore.user?.latitude ?? 0,
                longitude: userStore.user?.longitude ?? 0,
              }}
              onSubmit={(values) => updateUserLocation(values)}
            >
              {({ handleSubmit, setFieldValue, isValid, isSubmitting, values }) => (
                <Form className="ui form error" onSubmit={handleSubmit}>
                  <Header content={t('setupProfileLocation.locationDetails')} sub color="teal" />
                  <GameLocationPicker
                    onLocationSelect={(lat, lng) => {
                      if (lat !== values.latitude) setFieldValue("latitude", lat);
                      if (lng !== values.longitude) setFieldValue("longitude", lng);
                    }}
                    initialLat={values.latitude}
                    initialLng={values.longitude}
                  />
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={updatingLocation}
                    floated="right"
                    positive
                    type="submit"
                    content={t('setupProfileLocation.saveLocation')}
                  />
                </Form>
              )}
            </Formik>
          </Segment>
        </Grid.Column>
      </Grid>
    </Tab.Pane>
  );
});